/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Status_Starting_ExportInputs */



/**
* | output |
* | --- |
* | "Starting export..." |
*
* @param {Ateliere_Connect_Status_Starting_ExportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_status_starting_export = /** @type {((inputs?: Ateliere_Connect_Status_Starting_ExportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Status_Starting_ExportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Démarrage de l’exportation...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export wird gestartet...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avvio esportazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начало экспорта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iniciando exportación...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开始导出...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートを開始しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात शुरू हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iniciando a exportação...")
	return /** @type {LocalizedString} */ ("Starting export...")
});